import { CommonModule } from '@angular/common';
import { Component, effect, Input, OnInit, signal, untracked } from '@angular/core';

@Component({
  selector: 'loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class LoadingComponent implements OnInit {

  @Input() title: string;
  @Input() description: string;
  @Input() condensed = false;
  @Input() size: string;
  @Input() showOldLoading = true;

  animations = {
    round: signal(false),
    grouping: signal(false)
  }
  
  constructor() {
    if(!this.showOldLoading) {
      effect(() => {
        if(this.animations.round()) {
          setTimeout(() => {
            untracked(() => {
              this.animations.round.set(false)
              this.animations.grouping.set(true)
            })
          }, 300)
        }
      })
  
      effect(() => {
        if(this.animations.grouping()) {
          setTimeout(() => {
            untracked(() => {
              this.animations.round.set(true)
              this.animations.grouping.set(false)
            })
          }, 2000)
        }
      })
    }
  }

  ngOnInit(): void {
    if(!this.showOldLoading) {
      this.animations.round.set(true)
    }
  }
}
